import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Home,
  Leaf,
  Settings,
  ShoppingCart,
  ShoppingBasket,
  CircleUser,
  Bot,
  Tractor,
  Users,
  Calendar,
  DollarSign,
  ShoppingBag,
  PackageIcon,
  MessageCircle
} from "lucide-react";
import robot from "../../../assets/bot-small.png";

export default function MobileNavbar() {
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const isExpertPath = location.pathname.includes("/expert-dashboard");
  const isRetailerPath = location.pathname.includes("/retailer-dashboard");
  
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkIfMobile();
    window.addEventListener("resize", checkIfMobile);

    return () => window.removeEventListener("resize", checkIfMobile);
  }, []);

  const isActive = (path) => {
    if (path === "/farmer-dashboard") return location.pathname === "/farmer-dashboard";
    if (path === "/expert-dashboard") return location.pathname === "/expert-dashboard";
    if (path === "/retailer-dashboard") return location.pathname === "/retailer-dashboard";
    if (path === "/farmer-dashboard/produce") return location.pathname.includes("/produce");
    if (path === "/farmer-dashboard/myfarm") return location.pathname.includes("/myfarm");
    if (path === "/farmer-dashboard/sell") return location.pathname.includes("/sell");
    if (path === "/farmer-dashboard/ai") return location.pathname.includes("/ai");
    if (path === "/expert-dashboard/clients") return location.pathname.includes("/clients");
    if (path === "/expert-dashboard/appointments") return location.pathname.includes("/appointments");
    if (path === "/expert-dashboard/earnings") return location.pathname.includes("/earnings");
    if (path === "/retailer-dashboard/inventory") return location.pathname.includes("/inventory");
    if (path === "/retailer-dashboard/orders") return location.pathname.includes("/orders");
    if (path === "/retailer-dashboard/messages") return location.pathname.includes("/messages");
    return false;
  };

  if (!isMobile) return null;

  // Farmer navigation items
  const farmerNavItems = [
    { path: "/farmer-dashboard", icon: Home, label: "Overview" },
    { path: "/farmer-dashboard/produce", icon: Leaf, label: "Produce" },
    { path: "/farmer-dashboard/myfarm", icon: Tractor, label: "MyFarm" },
    { path: "/farmer-dashboard/sell", icon: ShoppingBasket, label: "Sell" },
    { path: "/farmer-dashboard/ai", icon: Bot, label: "AI" },
  ];

  // Expert navigation items
  const expertNavItems = [
    { path: "/expert-dashboard", icon: Home, label: "Overview" },
    { path: "/expert-dashboard/appointments", icon: Calendar, label: "Appointments" },
    { path: "/expert-dashboard/earnings", icon: DollarSign, label: "Earnings" },
    { path: "/expert-dashboard/ai", icon: Bot, label: "AI" },
  ];

  // Retailers navigation items
  const RetailersNavItems = [
    { path: "/retailer-dashboard", icon: Home, label: "Overview" },
    { path: "/retailer-dashboard/inventory", icon: ShoppingCart, label: "Inventory" },
    { path: "/retailer-dashboard/orders", icon: ShoppingBag, label: "Orders" },
    { path: "/retailer-dashboard/messages", icon: MessageCircle, label: "Messages" },
   
  ];

  const navItems = isExpertPath ? expertNavItems : isRetailerPath ? RetailersNavItems : farmerNavItems;

  return (
    <nav className="mobile-navbar">
      {navItems.map((item, index) => (
        <div
          key={index}
          className={`nav-item ${isActive(item.path) ? "active" : ""}`}
          onClick={() => navigate(item.path)}
        >
          <div className="nav-icon-container">
            <item.icon className="nav-icon" size={20} />
          </div>
          <span className="nav-label">{item.label}</span>
        </div>
      ))}
    </nav>
  );
}